import { render } from "./PandM.vue?vue&type=template&id=47cc3a1e&scoped=true"
import script from "./PandM.vue?vue&type=script&lang=js"
export * from "./PandM.vue?vue&type=script&lang=js"

import "./PandM.vue?vue&type=style&index=0&id=47cc3a1e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47cc3a1e"]])

export default __exports__